export default {"src":"https://fishbrain.com/_next/static/media/morning.8eaf2fcf.svg","height":44,"width":64,"blurWidth":0,"blurHeight":0};